import {
  ProgramMetricCard,
  colors
} from '../ProgramMetricCard/ProgramMetricCard'
import { Grid, Loader } from 'semantic-ui-react'
import { Icons } from '@120wateraudit/envirio-components'
import { FacilityMetricsQuery } from '../../rpcs/FacilityMetricsQuery'
import { facilityMetrics_metrics } from '../../data-access/__generated__/types'

interface FacilityCountProps {
  facilityId: number
}

export const FacilityCountsCards = ({
  facilityId
}: FacilityCountProps): JSX.Element => (
  <FacilityMetricsQuery variables={{ facilityId }}>
    {({ data, loading }) => {
      if (loading) {
        return <Loader />
      }

      if (!data || !data.metrics) {
        return null
      }

      const { fixturesTested, samplesAnalyzed, exceedancesFound } = data.metrics
      return (
        <MetricCards
          fixturesTested={fixturesTested}
          samplesAnalyzed={samplesAnalyzed}
          exceedancesFound={exceedancesFound}
        />
      )
    }}
  </FacilityMetricsQuery>
)

export enum Color {
  Blue = 'blue',
  Green = 'green',
  Red = 'red'
}

const MetricCards = ({
  fixturesTested,
  samplesAnalyzed,
  exceedancesFound
}: facilityMetrics_metrics) => (
  <Grid columns="equal" stackable>
    <Grid.Row>
      <Grid.Column>
        <FixturesTestedMetricCard count={fixturesTested} />
      </Grid.Column>
      <Grid.Column>
        <SamplesAnalyzedMetricCard count={samplesAnalyzed} />
      </Grid.Column>
      <Grid.Column>
        <ExceedancesFoundMetricCard count={exceedancesFound} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

interface CountCardProps {
  count: number
}

const FixturesTestedMetricCard = ({ count }: CountCardProps) => (
  <ProgramMetricCard
    color={Color.Green}
    icon={<Icons.SquareFaucet color={colors.icon.green} />}
    metric={count}
    label="Fixtures Tested"
  />
)

const SamplesAnalyzedMetricCard = ({ count }: CountCardProps) => (
  <ProgramMetricCard
    color={Color.Blue}
    icon={<Icons.Drop color={colors.icon.blue} />}
    metric={count}
    label="Samples Analyzed"
  />
)

const ExceedancesFoundMetricCard = ({ count }: CountCardProps) => (
  <>
    <ProgramMetricCard
      color={Color.Red}
      icon={<Icons.Error color={colors.icon.red} />}
      metric={count}
      label="Active Exceedances"
    />
  </>
)
